import React from "react";
import { Award, ShieldCheck, GraduationCap, Trophy, Newspaper } from "lucide-react";

/**
 * TrustStrip — thin, high-signal credibility bar shown above the hero fold.
 *
 * Design choices:
 *  • Deep navy background (matches hero-video overlay), amber accents
 *  • 5 monogram-style chips: kicker (small caps, gray) + line (bold, cream)
 *  • Horizontally scrollable on mobile, evenly distributed on ≥sm
 *  • No copyrighted logos — typography + lucide-react icons carry the credibility
 */
const items = [
  { icon: Newspaper,     kicker: "Featured in",          line: "Lokmat", tone: "amber" },
  { icon: GraduationCap, kicker: "Faculty Bench",        line: "IIT · VNIT · AIIMS", tone: "cyan" },
  { icon: ShieldCheck,   kicker: "Test Engine",          line: "NTA-Compliant", tone: "emerald" },
  { icon: Award,         kicker: "Founded By",           line: "VNIT Alumni", tone: "amber" },
  { icon: Trophy,        kicker: "JEE Adv 2026 · IIT Dhanbad", line: "Akshara Wanjari", tone: "amber" },
];

const toneMap = {
  amber:   "text-amber-300",
  cyan:    "text-cyan-300",
  emerald: "text-emerald-300",
};

export const TrustStrip = () => {
  return (
    <div
      data-testid="trust-strip"
      className="w-full bg-[#0B0F1A] border-b border-white/10 relative overflow-hidden"
    >
      {/* subtle yellow underline glow */}
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#F4C430]/60 to-transparent" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="flex items-center gap-x-8 gap-y-2 overflow-x-auto sm:overflow-visible sm:justify-between py-3 no-scrollbar"
          role="list"
          aria-label="Institutional credibility"
        >
          {items.map(({ icon: Icon, kicker, line, tone }, idx) => (
            <div
              key={idx}
              role="listitem"
              data-testid={`trust-chip-${idx}`}
              className="flex items-center gap-2.5 shrink-0 group"
            >
              <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-[#F4C430] border border-[#F4C430] text-[#0B0F1A] shadow-[0_2px_10px_-2px_rgba(244,196,48,0.6)] group-hover:brightness-110 transition-all">
                <Icon className="w-4 h-4" />
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-[9px] font-black text-white/70 tracking-widest uppercase">
                  {kicker}
                </span>
                <span className="text-[11px] sm:text-xs font-black text-[#F4C430] whitespace-nowrap">
                  {line}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustStrip;
